import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

const BUNNY_STORAGE_ZONE = "chat-alguidance";
const BUNNY_STORAGE_ENDPOINT = "storage.bunnycdn.com";
const BUNNY_API_KEY = "454c58f0-be8d-45ef-83d4d2522c4b-8d6b-45a9";
const apiBase = process.env.REACT_APP_API;

export const fetchQuizzesByQuotaId = async (quotaId, search = "", page = 1, limit = 10) => {
  if (!quotaId) {
    throw new Error("Quota ID is required");
  }

  try {
    const response = await axios.get(`${apiBase}/quize/`, {
      params: {
        quotaId,
        search,
        page,
        limit
      }
    });

    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "Failed to fetch quizzes";
    console.error("Error fetching quizzes:", error);
    throw new Error(errorMessage);
  }
};

export const createQuiz = async ({ quotaId, title, timeLimit, allowedAttempts, status }) => {
  const response = await fetch(`${apiBase}/quize/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      quotaId,
      title,
      timeLimit: timeLimit.toString(),
      allowedAttemps: allowedAttempts.toString(),
      status: status.toString()
    })
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error creating quiz: ${errorText}`);
  }

  return await response.json();
};


export const fetchQuizById = async (quizId) => {
  const response = await fetch(`${apiBase}/quize/${quizId}`);
  if (!response.ok) throw new Error("Failed to fetch quiz data");
  return await response.json();
};

export const updateQuiz = async (quizId, updatedData) => {
  const response = await fetch(`${apiBase}/quize/${quizId}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedData)
  });

  if (!response.ok) throw new Error("Failed to update quiz");
  return await response.json();
};



export const uploadQuestionImg = async (file) => {
    if (!file) return null;
    
    const fileName = `${uuidv4()}-${file.name}`;
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      const response = await fetch(`https://sg.storage.bunnycdn.com/chat-alguidance/${fileName}`, {
        method: 'PUT',
        headers: {
          'AccessKey': BUNNY_API_KEY
        },
        body: file
      });
      
      if(response.ok)console.log("hello")
      if (!response.ok) {
        throw new Error('Failed to upload image to Bunny.net');
      }
      
      // Return the CDN URL
      return `https://${BUNNY_STORAGE_ZONE}.b-cdn.net/${fileName}`;
    } catch (error) {
      console.error("Error uploading image to Bunny.net:", error);
      return null;
    }
  };


export const createQuestion = async (questionData) => {
  try {
    const formattedData = {
      ...questionData,
      options: questionData.options.map(option => ({
        text: option.text,
        isCorrect: option.isCorrect
      }))
    };
    
    const { quizId } = questionData;
    const response = await fetch(`${apiBase}/quize/${quizId}/questions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formattedData)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to create question');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error creating question:', error);
    throw error;
  }
};

export const  createCompleteQuestion = async (questionData) =>{
    const questionPayload = {
        questionText: questionData.question_text,
        questionImg: questionData.question_img,
        points : questionData.points.toString(),
        isPanelty : questionData.isPanelty ? 1 : 0,
    };

    try {
        // Create question
        const questionRes = await fetch(`${apiBase}/quize/question/${questionData.quizId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(questionPayload)
        });

        const questionResData = await questionRes.json();

        if (!questionRes.ok) {
            throw new Error(questionResData.message || "Failed to create question");
        }

        const questionId = questionResData.question_id;

        // Create answers
        for (const answer of questionData.answers) {
            const answerPayload = {
                answerText: answer.answer_text,
                answerImg: answer.answer_img || "",  // optional field
                isCorrect: answer.is_correct ? 1 : 0
            };

            const answerRes = await fetch(`${apiBase}/quize/answer/${questionId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(answerPayload)
            });

            const answerResData = await answerRes.json();

            if (!answerRes.ok) {
                throw new Error(answerResData.message || "Failed to create answer");
            }
        }

        console.log("Question and answers created successfully.");
    } catch (error) {
        console.error("Error:", error.message);
    }
}


export const fetchQuestionDetails = async (questionId) => {
  try {
    const response = await axios.get(`${apiBase}/quize/question/${questionId}`);
    return response.data;
  } catch (error) {
    // Enhanced error handling
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new Error(error.response.data.message || 'Failed to fetch question details');
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error('No response received from server');
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error('Error setting up the request');
    }
  }
};


export const updateQuestionWithAnswers = async (updateQuestionData) =>
{
    try {
        // Update question first
        const questionUpdateResponse = await fetch(`${apiBase}/quize/question/${updateQuestionData.questionId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                questionText: updateQuestionData.question_text,
                questionImg: updateQuestionData.question_img || '',
                points : updateQuestionData.points.toString(),
                isPanelty : updateQuestionData.isPanelty ? 1 : 0,
            })
        });

        if (!questionUpdateResponse.ok) {
            throw new Error('Failed to update question');
        }

        // Update answers
        const answerUpdatePromises = updateQuestionData.answers.map(async (answer) => {
            const response = await fetch(`${apiBase}/quize/answer/${answer.answer_id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    answerText: answer.answer_text,
                    isCorrect: answer.is_correct ? '1' : '0',
                    answering: answer.answer_text // assuming this is what 'answering' field represents
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to update answer with ID ${answer.answer_id}`);
            }

            return response;
        });

        // Wait for all answer updates to complete
        await Promise.all(answerUpdatePromises);

        return {
            questionUpdateResponse,
            answerUpdateResponses: await Promise.all(answerUpdatePromises)
        };
    } catch (error) {
        console.error('Error updating question and answers:', error);
        throw error;
    }

}

// quizApiService.js
export const fetchQuizAnalytics = async (quizId, page = 1, limit = 5) => {
  try {
    const response = await fetch(`${apiBase}/quize/analytics/${quizId}?page=${page}&limit=${limit}`);
    
    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch quiz analytics:", error);
    throw error;
  }
};

export const downloadExcelFile = async (quizId) => {
  try {
    const response = await fetch(`${apiBase}/quize/analytics/${quizId}/excel`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the Excel file.');
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `quiz_analytics_${quizId}.xlsx`; // File name includes quizId for uniqueness
    a.click();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the Excel file:', error);
    throw error;
  }
};
